import './PinpointPageModals.scss';

import React from 'react';
import Modal from 'components/Modal';
import moment from 'moment';
import { Circle, GoogleMap, Marker, withGoogleMap } from 'react-google-maps';
import classNames from 'classnames';

import Icon from 'components/Icon';
import ModalButton from 'components/ModalButton';
import SlideList from 'components/SlideList';

import { COLORS } from 'utils/constants';

const radii = {
    immediate: {
        radius: 200,
        zoom: 16
    },
    near: {
        radius: 500,
        zoom: 14
    },
    far: {
        radius: 1000,
        zoom: 13
    }
};


const Map = withGoogleMap(props => (
    <GoogleMap ref={props.onMapLoad}
               defaultZoom={radii[props.pinpoint.broadcast].zoom}
               defaultCenter={{lat: props.pinpoint.latitude, lng: props.pinpoint.longitude}}>
        <Marker position={new window.google.maps.LatLng(props.pinpoint.latitude, props.pinpoint.longitude)}/>
        <Circle center={new window.google.maps.LatLng(props.pinpoint.latitude, props.pinpoint.longitude)}
                radius={radii[props.pinpoint.broadcast].radius}
                options={{
                    fillColor: COLORS.siteBlue,
                    fillOpacity: .2,
                    strokeColor: COLORS.siteBlue,
                    strokeOpacity: 1,
                    strokeWeight: 2
                }} />
    </GoogleMap>
));


export default class GPSDetailsModal extends React.Component {
    static propTypes = {
        closeModal: React.PropTypes.func.isRequired,
        deletePinpoint: React.PropTypes.func.isRequired,
        isSaving: React.PropTypes.bool.isRequired,
        openModal: React.PropTypes.func.isRequired,
        pinpoint: React.PropTypes.object.isRequired,
        show: React.PropTypes.bool.isRequired
    };

    render() {
        let { closeModal, pinpoint, show } = this.props;

        if(Object.keys(pinpoint).length > 0 && pinpoint.id != null) {
            return (
                <Modal show={show}
                       className="pinpoint-details gps-details"
                       handleClose={closeModal.bind(this)}
                       width="wide">
                    <header className="pinpoint-details__header gps-details__header modal__header">
                        <div className="pinpoint-details__thumbnail gps-details__thumbnail modal__thumbnail" >
                            {pinpoint.thumbnail ? (
                                <div className="modal__thumbnail--image pinpoint-details__thumbnail--image">
                                    <img src={`${process.env.API_URL}rest/file/${pinpoint.thumbnail.id}`} alt={pinpoint.name} />
                                </div>
                            ) : null}
                        </div>
                        <div className="gps-details__icon-name">
                            <Icon icon="gps" />
                            <div className="gps-details__title">
                                Geofence
                                <div className="gps-details__name">
                                    {pinpoint.name}
                                </div>
                            </div>
                        </div>
                    </header>
                    <div className="details-modal__info pinpoint-details__info">
                        <div className="pinpoint-details__description modal__description">
                            Created by {pinpoint.creator.firstName} {pinpoint.creator.lastName} | {moment(pinpoint.created).format('MM/DD/YY')}
                        </div>
                    </div>
                    <div className="details-modal__info pinpoint-details__info">
                        {pinpoint.address != null ? (
                            <div>
                                <div className="pinpoint-details__name modal__name">
                                    APPROX. ADDRESS:
                                </div>
                                <div className="pinpoint-details__description modal__description">
                                    {pinpoint.address}
                                </div>
                            </div>
                        ) : null}

                        <div className={classNames('pinpoint-details__name', 'modal__name', {'modal__name--secondary': pinpoint.address != null})}>
                            LAT: <strong>{pinpoint.latitude}</strong> | LONG: <strong>{pinpoint.longitude}</strong>
                        </div>
                        <div className="pinpoint-details__description modal__description">
                            Radius: <strong>{radii[pinpoint.broadcast].radius} meters</strong>
                        </div>
                    </div>
                    <div className="details-modal__map gps-details__map">
                        <Map pinpoint={pinpoint}
                             containerElement={<div style={{ height: `100%` }} />}
                             mapElement={<div style={{ height: `100%` }} />} />
                    </div>
                    <div className="details-modal__info pinpoint-details__info">
                        <div className="pinpoint-details__name modal__name">
                            Notification
                        </div>
                        <div className="pinpoint-details__description modal__description">
                            {pinpoint.notificationMessage || '[No Notification Specified]'}
                        </div>
                    </div>
                    <div className="details-modal__info pinpoint-details__info">
                        <div className="pinpoint-details__name modal__name">
                            Notes
                        </div>
                        <div className="pinpoint-details__description modal__description">
                            {pinpoint.notes || '[No notes]'}
                        </div>
                    </div>
                    <SlideList className="pinpoint-details__assignments-list pinpoint-details__list details-modal__list"
                               count={pinpoint.assignmentIds.length}
                               icon="assignments"
                               items={pinpoint.assignments || []}
                               title="Assignments"
                               type="assignments--names-only" />

                    <div className="modal__buttons">
                        {/*<ModalButton disabled={isSaving === true}
                                     icon="edit"
                                     onClick={openModal.bind(this, MODALS.PINPOINT_EDIT)}
                                     text="Edit" />
                        <ModalButton disabled={isSaving === true}
                                     icon="delete"
                                     onClick={deletePinpoint.bind(this, pinpoint)}
                                     text="Delete" />*/}
                        <ModalButton icon="check"
                                     onClick={closeModal.bind(this)}
                                     text="Done" />
                    </div>
                </Modal>
            );
        } else {
            return null;
        }
    }
}




// WEBPACK FOOTER //
// ./src/containers/PinpointsPage/modals/GPSDetailsModal.js